// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xg7o","colMin":"styles_colMin__3VsA8"};